import React from 'react';
import { FileText } from 'lucide-react';
export const ActiveForms = () => {
  return <div className="mb-8" data-id="element-5">
      <h2 className="text-lg font-medium text-gray-800 mb-4" data-id="element-6">Active Forms</h2>
      <div className="bg-white rounded-lg shadow-sm p-4" data-id="element-7">
        <div className="flex items-center space-x-4" data-id="element-8">
          <div className="bg-green-100 h-12 w-12 rounded-full flex items-center justify-center flex-shrink-0" data-id="element-9">
            <FileText className="h-6 w-6 text-green-600" data-id="element-10" />
          </div>
          <div className="flex-1" data-id="element-11">
            <h3 className="text-sm font-medium text-gray-800" data-id="element-12">
              Update the academic data for the...
            </h3>
            <p className="text-xs text-gray-500 mt-1" data-id="element-13">
              We would like to remind you of the...
            </p>
          </div>
        </div>
      </div>
    </div>;
};